export function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}
//# sourceMappingURL=invariant.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@formatjs/intl-utils/lib/invariant.js
// module id = 574
// module chunks = 121